import Policy from './views/policy.c';
export default Policy;
